var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",attrs:{"id":"devices"}},[_c('h2',{staticClass:"display-4"},[_vm._v("Dispositivi")]),_c('hr'),_c('DeviceList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }